/* components/ThemeSwitch.svelte generated by Svelte v3.44.1 */
import {
	SvelteComponent,
	component_subscribe,
	create_component,
	destroy_component,
	init,
	mount_component,
	safe_not_equal,
	transition_in,
	transition_out
} from "svelte/internal";

import Switch from './Switch.svelte';
import { theme } from '../stores.js';
import { DARK_THEME, LIGHT_THEME } from '../const.js';

function create_fragment(ctx) {
	let switch_1;
	let current;

	switch_1 = new Switch({
			props: {
				value: /*$theme*/ ctx[0] === DARK_THEME,
				onChange: /*onChange*/ ctx[1]
			}
		});

	return {
		c() {
			create_component(switch_1.$$.fragment);
		},
		m(target, anchor) {
			mount_component(switch_1, target, anchor);
			current = true;
		},
		p(ctx, [dirty]) {
			const switch_1_changes = {};
			if (dirty & /*$theme*/ 1) switch_1_changes.value = /*$theme*/ ctx[0] === DARK_THEME;
			switch_1.$set(switch_1_changes);
		},
		i(local) {
			if (current) return;
			transition_in(switch_1.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(switch_1.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(switch_1, detaching);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let $theme;
	component_subscribe($$self, theme, $$value => $$invalidate(0, $theme = $$value));

	function onChange(checked) {
		theme.set(checked ? DARK_THEME : LIGHT_THEME);
	}

	theme.subscribe(value => {
		localStorage.setItem('theme', value);
		document.body.setAttribute('theme', value);
	});

	return [$theme, onChange];
}

class ThemeSwitch extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, {});
	}
}

export default ThemeSwitch;